import { useState, useEffect, useCallback } from 'react';
import { getProductById } from '../services/productService';

const RECENTLY_VIEWED_KEY = 'shopscout_recently_viewed';
const MAX_RECENTLY_VIEWED = 8; // Keep it small for minimal implementation

export const useRecentlyViewed = () => {
  const [recentlyViewedProducts, setRecentlyViewedProducts] = useState([]);

  // Load recently viewed products from localStorage on mount
  useEffect(() => {
    try {
      const stored = localStorage.getItem(RECENTLY_VIEWED_KEY);
      if (stored) {
        const ids = JSON.parse(stored);
        const products = ids
          .map(id => {
            try {
              return getProductById(id);
            } catch (error) {
              return null; // Product might not exist anymore
            }
          })
          .filter(Boolean)
          .slice(0, MAX_RECENTLY_VIEWED);
        
        setRecentlyViewedProducts(products);
      }
    } catch (error) {
      console.error('Error loading recently viewed:', error);
    }
  }, []);

  const addToRecentlyViewed = useCallback((productId) => {
    try {
      const stored = localStorage.getItem(RECENTLY_VIEWED_KEY);
      let ids = stored ? JSON.parse(stored) : [];
      
      // Remove if already exists and add to beginning
      ids = ids.filter(id => id !== productId);
      ids = [productId, ...ids].slice(0, MAX_RECENTLY_VIEWED);
      
      localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(ids));
      
      // Update state
      const products = ids
        .map(id => {
          try {
            return getProductById(id);
          } catch (error) {
            return null;
          }
        })
        .filter(Boolean);
      
      setRecentlyViewedProducts(products);
    } catch (error) {
      console.error('Error saving recently viewed:', error);
    }
  }, []);

  return { recentlyViewedProducts, addToRecentlyViewed };
};
